import type { ReactNode } from "react";
import { PaneHeaderContext } from "feat/layout/panes/pane-context";
import ItineraryCarousel, { useIsHeaderVisible } from "home/components/carousel/ItineraryCarousel";
import { HEADER_HEIGHT } from "state/scrollState/scrollContext";
import { useTopInset } from "state/windowState/window.store";
import { HomeScrollAwayContent } from "./home-scroll-away";

/** A leading pane headed by the itinerary header, as Home, Chat and Team are in one column. */
export function ItineraryHeaderPane({ children }: { children: ReactNode }) {
  const topInset = useTopInset();
  const headerOffset = useIsHeaderVisible() ? HEADER_HEIGHT + topInset : 0;

  return (
    <PaneHeaderContext.Provider value={true}>
      <ItineraryCarousel />
      <HomeScrollAwayContent headerOffset={headerOffset}>{children}</HomeScrollAwayContent>
    </PaneHeaderContext.Provider>
  );
}
